import { render, staticRenderFns } from "./MyCustomerProfile.vue?vue&type=template&id=75c2dfb3&"
import script from "./MyCustomerProfile.vue?vue&type=script&lang=js&"
export * from "./MyCustomerProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports